import styled from "styled-components";

export const Label = styled.label`
  display: grid;
  grid-template-columns: ${({ theme }) => theme.sizeRadio} auto;
  align-items: center;
  gap: 16px;
  cursor: pointer;
  user-select: none;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
`;
